import React, { useState } from 'react';
import TechArray from './techArray';

interface ProjectCardProps {
    title: string;
    body: string;
    tech?: string;
    img?: string;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ title, body, tech, img }) => {
    return (
        <div className="group cursor-pointer backdrop-blur-sm hover:bg-zinc-200 duration-75 hover:shadow-lg rounded-xl p-4 overflow-hidden" 
            onClick={() => window.location.href = '/guaki'}>
            <h2 className='group-hover:text-green-600 font-semibold text-gray-700 mb-1'>
                {title}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" 
                    className="group-hover:fill-green-500 group-hover:-translate-y-1 group-hover:translate-x-1 inline-block h-4 w-4 shrink-0 transition-transform ml-1 translate-y-px" 
                    aria-hidden="true">
                    <path fillRule="evenodd" d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z" clipRule="evenodd"></path>
                </svg>
            </h2>
            <p className='text-gray-700 font-normal mb-2'>{body}</p>
            {tech && <TechArray tech={tech} />}
            
            <div className="max-h-0 group-hover:max-h-60 transition-all duration-500 overflow-hidden columns-3">
                <img
                    className=""
                    src={"/guaki/PantryFull.png"}
                    alt="Project image"
                />
                <img
                    className=""
                    src={"/guaki/PlannerSearch.png"}
                    alt="Project image"
                />
                <img
                    className=""
                    src={"/guaki/PantryFull.png"}
                    alt="Project image"
                />
            </div>
        </div>
    );
};

export default ProjectCard;
